/**
 * @author caijianjia
 * @date 2020/3/28 11:09 上午
 */

import * as Resource from './resource'
import * as Game from './game'
import * as Form from './form'
import * as QuestionBank from './questionbank'

export default {
  ...Resource,
  ...Game,
  ...Form,
  ...QuestionBank
}
